import { useCallback, useEffect, useState } from 'react';

export interface Ruta {
  path: string;
  params: URLSearchParams;
}

const leer = (): Ruta => ({
  path: window.location.pathname.replace(/\/+$/, '') || '/',
  params: new URLSearchParams(window.location.search),
});

/** Ruteo mínimo sobre la History API: la URL siempre refleja la búsqueda, así se puede compartir. */
export function useRuta() {
  const [ruta, setRuta] = useState<Ruta>(leer);

  useEffect(() => {
    const alVolver = () => setRuta(leer());
    window.addEventListener('popstate', alVolver);
    return () => window.removeEventListener('popstate', alVolver);
  }, []);

  const navegar = useCallback((url: string, opciones?: { reemplazar?: boolean; arriba?: boolean }) => {
    if (url === window.location.pathname + window.location.search) return;
    if (opciones?.reemplazar) window.history.replaceState(null, '', url);
    else window.history.pushState(null, '', url);
    setRuta(leer());
    if (opciones?.arriba) window.scrollTo({ top: 0 });
  }, []);

  return { ruta, navegar };
}

export const conParams = (path: string, params: URLSearchParams) => {
  const s = params.toString();
  return s ? `${path}?${s}` : path;
};
